/*
 * @Author: ts.r
 * @Date: 2020-11-30 15:21:56
 * @LastEditTime: 2021-02-07 19:48:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cmine-pro-fe/src/components/enroll/login/api.js
 */
import { NGET, NPOST } from '@/utils/net-work'

const baseUri = '/api/auth'

function getQrToken(params) {
  return NGET(baseUri + '/qr/token', params)
}
function getQrCode(params) {
  return NGET(baseUri + '/qr/code', params)
}
function getTokenCheck(params) {
  return NPOST(baseUri + '/qr/token-check', params)
}
function captchaCheck(params) {
  return NPOST(baseUri + '/captcha', params)
}
function verificationCode(params) {
  return NGET(baseUri + '/verification-code', params)
}
function getMessageCode(params) {
  return NGET(baseUri + '/message_login', params)
}
function messageLogin(params) {
  return NPOST(baseUri + '/message_login', params)
}
// 获取公钥、保险柜钥匙
function rsaKeyPair(params) {
  return NGET('/api/system/security/rsa_key_pair', params)
}

export {
  getQrToken,
  getQrCode,
  getTokenCheck,
  captchaCheck,
  verificationCode,
  getMessageCode,
  messageLogin,
  rsaKeyPair
}
